import React from 'react';

interface PropertyDescriptionProps {
  description: string;
}

const PropertyDescription: React.FC<PropertyDescriptionProps> = ({
  description
}) => {
  return (
    <div className="bg-white p-5 sm:p-6 md:p-8 rounded-xl shadow-lg">
      <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-4 sm:mb-5 md:mb-6">
        Description
      </h2>
      <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
        {description}
      </p>
    </div>
  );
};

export default PropertyDescription;
